const SPREADSHEET_ID = '1o_Bzs6LWVlRLss2QQEFukiY0lZbLCpp0tZEMorvY8Eo';
const GOOGLE_API_KEY = 'AIzaSyBZI4rkLa0w8THS05gmcXClESHjBI_om38';
    export {SPREADSHEET_ID,GOOGLE_API_KEY}
